module.exports = __webpack_public_path__ + "static/media/users-slash.8426375f.svg";